import React, { useCallback, useEffect, useState } from "react";
import LogoutIcon from "@mui/icons-material/Logout";
import SearchIcon from "@mui/icons-material/Search";
import LocalPrintshopIcon from "@mui/icons-material/LocalPrintshop";
import ReplayIcon from "@mui/icons-material/Replay";
import LoopIcon from "@mui/icons-material/Loop";
import DiscountIcon from "@mui/icons-material/Discount";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import BackspaceIcon from "@mui/icons-material/Backspace";
import DraftsIcon from "@mui/icons-material/Drafts";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import CardTravelIcon from "@mui/icons-material/CardTravel";
import CurrencyExchangeIcon from "@mui/icons-material/CurrencyExchange";
import BlockIcon from "@mui/icons-material/Block";
import CleaningServicesIcon from "@mui/icons-material/CleaningServices";
import SubdirectoryArrowRightIcon from "@mui/icons-material/SubdirectoryArrowRight";
import { useDispatch, useSelector } from "react-redux";

import PauseIcon from "@mui/icons-material/Pause";
import baseUrl from "../../../api/baseUrl";
import Popup from "reactjs-popup";
import EnterClick from "./popups/EnterClick";
import CommonModal from "../../../components/commonModal/CommonModal";
import KeyButton from "./KeyButton";
import {
  backSpace,
  hold,
  posCharButton,
  reCall,
} from "../../../store/pos/posSlice";
import ModelEmpty from "../../../components/commonModal/ModelEmpty";
import { getCurrencySymbol } from "../../../utils/currency/currencyUtils";
import { toast } from "react-toastify";
import InputText from "../../../components/inputs/InputText";
import "./DeliveryOrdersPopup.scss";

const keyboardLayout = {
  letters: [
    [
      { name: "q", icon: "Q" },
      { name: "w", icon: "W" },
      { name: "e", icon: "E" },
      { name: "r", icon: "R" },
      { name: "t", icon: "T" },
      { name: "y", icon: "Y" },
      { name: "u", icon: "U" },
      { name: "i", icon: "I" },
      { name: "o", icon: "O" },
      { name: "p", icon: "P" },
    ],
    [
      { name: "a", icon: "A" },
      { name: "s", icon: "S" },
      { name: "d", icon: "D" },
      { name: "f", icon: "F" },
      { name: "g", icon: "G" },
      { name: "h", icon: "H" },
      { name: "j", icon: "J" },
      { name: "k", icon: "K" },
      { name: "l", icon: "L" },
    ],
    [
      { name: "z", icon: "Z" },
      { name: "x", icon: "X" },
      { name: "c", icon: "C" },
      { name: "v", icon: "V" },
      { name: "b", icon: "B" },
      { name: "n", icon: "N" },
      { name: "m", icon: "M" },
    ],
  ],
  numpad: [
    [
      { name: "7", icon: "7" },
      { name: "8", icon: "8" },
      { name: "9", icon: "9" },
      { name: "addition", icon: "+" },
      { name: "backSpace", icon: "⌫" },
    ],
    [
      { name: "4", icon: "4" },
      { name: "5", icon: "5" },
      { name: "6", icon: "6" },
      { name: "subtrack", icon: "-" },
      { name: "percentage", icon: "%" },
    ],
    [
      { name: "1", icon: "1" },
      { name: "2", icon: "2" },
      { name: "3", icon: "3" },
      { name: "multiply", icon: "x" },
      { name: "divide", icon: "/" },
    ],
    [
      { name: ".", icon: "." },
      { name: "0", icon: "0" },
      { name: "00", icon: "00" },
      { name: "enter", icon: "↵" },
    ],
  ],
  controls: [
    { name: "clear", icon: "🧹" },
    { name: "hold", icon: "⏸" },
    { name: "reCall", icon: "🔁" },
    { name: " ", icon: "␣" },
    { name: "print", icon: "🖨️" },
    { name: "exit", icon: "⌨️" },
    { name: "lineDiscount", icon: "✏️" },
    { name: "open", icon: "🪑" },
    { name: "delivery", icon: "🛵" },
  ],
  smallkeyboard: [
    { name: "clear", icon: "🧹" },
    { name: "hold", icon: "⏸" },
    { name: "reCall", icon: "🔁" },
    { name: "print", icon: "🖨️" },
    { name: "exit", icon: "⌨️" },
    { name: "lineDiscount", icon: "✏️" },
    { name: "open", icon: "🪑" },
    { name: "delivery", icon: "🛵" },
  ],
};
const isNumeric = (value: any) => !isNaN(Number(value));

function ActionButtons({
  setopenOrder,
  onEditOrder,
  openKeyboard,
  setOpenKeyboard,
}: any) {
  const dispatch = useDispatch();
  const [openEnterModel, setOpenEnterModel] = React.useState(false);
  const [showTableOrderPopup, setShowTableOrderPopup] = useState(false);
  const [tableOrders, setTableOrders] = useState<any[]>([]);
  const [loadingTables, setLoadingTables] = useState(false);
  const [selectedTableOrders, setSelectedTableOrders] = useState<any[]>([]);
  const [selectedTable, setSelectedTable] = useState<any>(null);
  const currencySymbol = getCurrencySymbol();

  // State for order details modal
  const [showOrderDetails, setShowOrderDetails] = useState(false);
  const [orderDetails, setOrderDetails] = useState<any>(null);
  const [orderDetailsLoading, setOrderDetailsLoading] = useState(false);
  const [groupedOrders, setGroupedOrders] = useState<any>({});

  // Delivery Orders popup state (separate flow from dine-in Table Orders)
  const [showDeliveryPopup, setShowDeliveryPopup] = useState(false);
  const [loadingDeliveryOrders, setLoadingDeliveryOrders] = useState(false);
  const [deliveryOrders, setDeliveryOrders] = useState<any[]>([]);

  // "Mark Delivered" confirm popup — asks whether to collect payment
  // (cash-on-delivery) before finalizing the delivered status
  const [markDeliveredTarget, setMarkDeliveredTarget] = useState<any>(null);
  const [collectPaymentNow, setCollectPaymentNow] = useState(false);
  const [deliveryPayCash, setDeliveryPayCash] = useState("");
  const [deliveryPayCard, setDeliveryPayCard] = useState("");
  const [deliveryPayBank, setDeliveryPayBank] = useState("");
  const [submittingMarkDelivered, setSubmittingMarkDelivered] = useState(false);

  const actionArray = [
    { key: "backSpace", fn: backSpace },
    { key: "hold", fn: hold },
    { key: "hold", fn: hold },
    { key: "reCall", fn: reCall },
  ];

  // Handler for "open" button
  const handleOpenTableOrders = async () => {
    setLoadingTables(true);
    setShowTableOrderPopup(true);
    setSelectedTableOrders([]);
    setSelectedTable(null);
    try {
      // Fetch tables
      const tablesRes = await baseUrl.get("/branch/table/get-tables");
      const tables = tablesRes.data?.data || [];
      // For each table, fetch orders (parallel)
      const ordersPromises = tables.map((table: any) =>
        baseUrl
          .get(`/branch/order/get-orders-by-table/${table.id}`)
          .then((res) => {
            const orders = res.data?.data || [];
            // Count unique order numbers
            const uniqueOrderNumbers = Array.from(
              new Set(orders.map((o: any) => o.orderNumber)),
            );
            return {
              ...table,
              orders,
              orderCount: uniqueOrderNumbers.length, // Add count of unique orders
            };
          })
          .catch(() => {
            return {
              ...table,
              orders: [],
              orderCount: 0,
            };
          }),
      );
      const tablesWithOrders = await Promise.all(ordersPromises);
      setTableOrders(tablesWithOrders);
    } catch (err) {
      setTableOrders([]);
    }
    setLoadingTables(false);
  };

  // Handler for the separate "Delivery Orders" button — its own flow,
  // backed by the dedicated DeliveryOrders table, not tied to any physical table
  const handleOpenDeliveryOrders = async () => {
    setLoadingDeliveryOrders(true);
    setShowDeliveryPopup(true);
    try {
      const res = await baseUrl.get("/branch/delivery-order/pending-orders");
      const orders = res.data?.data || [];
      const grouped: any = {};
      orders.forEach((order: any) => {
        if (!grouped[order.orderNumber]) grouped[order.orderNumber] = [];
        grouped[order.orderNumber].push(order);
      });
      setDeliveryOrders(
        Object.entries(grouped).map(([orderNumber, items]) => ({
          orderNumber,
          items: items as any[],
        })),
      );
    } catch (err) {
      setDeliveryOrders([]);
    }
    setLoadingDeliveryOrders(false);
  };

  // Opens the confirm popup for marking an order delivered — lets staff
  // decide whether payment (cash on delivery) is being collected right now
  const handleOpenMarkDeliveredConfirm = (orderNumber: string, items: any[]) => {
    const payment = items[0]?.payment || null;
    setMarkDeliveredTarget({
      orderNumber,
      billNumber: items[0]?.billNumber || null,
      payment,
    });
    setCollectPaymentNow(false);
    setDeliveryPayCash("");
    setDeliveryPayCard("");
    setDeliveryPayBank("");
  };

  const handleConfirmMarkDelivered = async () => {
    if (!markDeliveredTarget) return;
    const { orderNumber, billNumber, payment } = markDeliveredTarget;

    setSubmittingMarkDelivered(true);
    try {
      if (collectPaymentNow && payment?.hasUnpaidAmount && billNumber) {
        const cash = Number(deliveryPayCash || 0);
        const card = Number(deliveryPayCard || 0);
        const bank = Number(deliveryPayBank || 0);
        if (cash + card + bank <= 0) {
          toast.error("Please enter a payment amount");
          setSubmittingMarkDelivered(false);
          return;
        }
        await baseUrl.post("/branch/sale/credit-payment", {
          billNumber,
          payments: [{ cash, card, bank }],
        });
      }

      await baseUrl.put(
        `/branch/delivery-order/order-number/${orderNumber}/status`,
        { status: "Delivered" },
      );
      toast.success(`Order ${orderNumber} marked as delivered!`);
      setMarkDeliveredTarget(null);
      handleOpenDeliveryOrders();
    } catch (err) {
      toast.error("Failed to mark order as delivered.");
    }
    setSubmittingMarkDelivered(false);
  };

  const handleCancelDeliveryOrder = async (orderNumber: string) => {
    if (window.confirm("Are you sure you want to cancel this delivery order?")) {
      try {
        await baseUrl.put(`/branch/delivery-order/cancel-order/${orderNumber}`);
        toast.success("Delivery order cancelled successfully!");
        handleOpenDeliveryOrders();
      } catch (err) {
        toast.error("Failed to cancel delivery order.");
      }
    }
  };

  // Keyboard click handler: always dispatch posCharButton for key input
  const onHandleClick = useCallback(
    (e: any) => {
      const { name, icon } = e;

      if (name === "exit") {
        setOpenKeyboard((prev: any) => !prev);
        return;
      }

      if (name === "exit") {
        setOpenKeyboard(!openKeyboard);
        return;
      }
      if (name === "open") {
        handleOpenTableOrders();
        return;
      }
      if (name === "delivery") {
        handleOpenDeliveryOrders();
        return;
      }

      // If it's a control key, dispatch its action
      const found = actionArray.find((item) => item.key === name);
      if (found) {
        dispatch(found.fn());
        return;
      }

      // For all other keys, dispatch posCharButton with icon (not name)
      dispatch(posCharButton(icon));
    },
    [dispatch],
  );

  // Fetch order details by orderNumber
  const handleViewOrderDetails = async (orderNumber: string) => {
    setOrderDetailsLoading(true);
    setShowOrderDetails(true);
    try {
      const res = await baseUrl.get(
        `/branch/order/get-order-by-order-number/${orderNumber}`,
      );
      setOrderDetails(res.data?.data || []);
    } catch (err) {
      setOrderDetails([]);
    }
    setOrderDetailsLoading(false);
  };

  // Group orders by orderNumber when a table is selected
  useEffect(() => {
    if (selectedTableOrders && selectedTableOrders.length > 0) {
      const grouped: any = {};
      selectedTableOrders.forEach((order: any) => {
        if (!grouped[order.orderNumber]) grouped[order.orderNumber] = [];
        grouped[order.orderNumber].push(order);
      });
      setGroupedOrders(grouped);
    } else {
      setGroupedOrders({});
    }
  }, [selectedTableOrders]);

  // Handler for Edit Order
  const handleEditOrder = (orderNumber: string, items: any[]) => {
    // Pass to parent (Pos/ProductList) to load in POS interface for editing
    if (onEditOrder) {
      onEditOrder(orderNumber, items);
    }
    setShowTableOrderPopup(false); // Close popup after clicking edit
  };

  // Handler for Cancel Order
  const handleCancelOrder = async (orderNumber: string) => {
    if (window.confirm("Are you sure you want to cancel this order?")) {
      try {
        await baseUrl.put(`/branch/order/cancel-order/${orderNumber}`);
        toast.success("Order cancelled successfully!");
        // Refresh the orders
        handleOpenTableOrders();
      } catch {

        toast.error("Failed to cancel order.");
      }
    }
  };

  return (
    <>
      {openKeyboard && (
        <div className="keyboard-container">
          <div className="keyboard-section">
            {keyboardLayout.letters.map((row, i) => (
              <div key={i} className="key-row">
                {row.map((key, j) => (
                  <KeyButton
                    key={j}
                    className="key-button"
                    icon={key.icon}
                    onClick={() => onHandleClick(key)}
                  />
                ))}
              </div>
            ))}
            <div className="key-row controls">
              {keyboardLayout.controls.map((control, i) => (
                <KeyButton
                  key={i}
                  className="control-button"
                  icon={control.icon}
                  onClick={() => onHandleClick(control)}
                />
              ))}
            </div>
          </div>
          <div className="numpad-section ">
            {keyboardLayout.numpad.map((row, i) => (
              <div key={i} className="key-row">
                {row.map((key, j) => (
                  <KeyButton
                    key={j}
                    className="key-button"
                    icon={key.icon}
                    onClick={() => onHandleClick(key)}
                  />
                ))}
              </div>
            ))}
          </div>
        </div>
      )}
      {!openKeyboard && (
        <div className={`smallkeyboard ${!openKeyboard ? "open" : "close"}`}>
          {keyboardLayout.smallkeyboard.map((control, i) => (
            <KeyButton
              key={i}
              className="control-button"
              icon={control.icon}
              onClick={() => onHandleClick(control)}
            />
          ))}
        </div>
      )}

      {openEnterModel && (
        <Popup
          open={openEnterModel}
          onClose={() => setOpenEnterModel(false)}
          closeOnDocumentClick
          modal
          overlayStyle={{ background: "rgba(0, 0, 0, 0.5)" }}
          contentStyle={{
            width: "300px",
            height: "200px",
            borderRadius: "10px",
          }}
          className="enter_model"
        >
          <EnterClick />
        </Popup>
      )}

      {/* Table Order Popup */}
      {showTableOrderPopup && (
        <ModelEmpty
          open={showTableOrderPopup}
          setopen={setShowTableOrderPopup}
          className="table-order-popup"
          title="Table Orders"
        >
          <div style={{ minWidth: 350, padding: 16 }}>
            {/* NEW: Display total orders count */}
            {!loadingTables && !selectedTable && (
              <div
                style={{
                  marginBottom: 16,
                  padding: 12,
                  background: "#f0f7ff",
                  borderRadius: 6,
                  border: "1px solid #1f6f8b",
                  textAlign: "center",
                }}
              >
                <strong style={{ fontSize: 16, color: "#1f6f8b" }}>
                  Total Orders:{" "}
                  {tableOrders.reduce(
                    (sum, table) => sum + (table.orderCount || 0),
                    0,
                  )}
                </strong>
              </div>
            )}

            {loadingTables ? (
              <div>Loading tables...</div>
            ) : (
              <>
                {!selectedTable && (
                  <div style={{ maxHeight: 600, overflowY: "auto" }}>
                    {tableOrders.length === 0 && <div>No tables found.</div>}
                    {tableOrders.map((table: any) => (
                      <button
                        key={table.id}
                        style={{
                          display: "block",
                          width: "100%",
                          textAlign: "left",
                          marginBottom: 8,
                          padding: 10,
                          border: "1px solid #eee",
                          borderRadius: 6,
                          background: "#f8f9fa",
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          setSelectedTable(table);
                          setSelectedTableOrders(table.orders || []);
                        }}
                      >
                        <div>
                          <strong>Table #{table.tableNumber}</strong> -{" "}
                          {table.person} Persons
                        </div>
                        <div style={{ fontSize: 13, color: "#888" }}>
                          Status: {table.status}
                        </div>
                        <div style={{ fontSize: 13, color: "#888" }}>
                          {/* UPDATED: Show order count instead of item count */}
                          Orders: {table.orderCount || 0}
                        </div>
                      </button>
                    ))}
                  </div>
                )}
                {selectedTable && (
                  <div>
                    <button
                      style={{
                        marginBottom: 10,
                        background: "none",
                        border: "none",
                        color: "#1f6f8b",
                        cursor: "pointer",
                        fontWeight: 500,
                        fontSize: 15,
                      }}
                      onClick={() => {
                        setSelectedTable(null);
                        setSelectedTableOrders([]);
                      }}
                    >
                      ← Back to Tables
                    </button>
                    <div style={{ marginBottom: 8 }}>
                      <strong>Table #{selectedTable.tableNumber}</strong> -{" "}
                      {selectedTable.person} Persons
                    </div>
                    <div style={{ marginBottom: 8 }}>
                      <strong>Status:</strong> {selectedTable.status}
                    </div>
                    <div style={{ marginBottom: 8 }}>
                      {/* UPDATED: Show order count instead of item count */}
                      <strong>Orders:</strong>{" "}
                      {Object.keys(groupedOrders).length}
                    </div>
                    {selectedTableOrders.length === 0 ? (
                      <div>No orders for this table.</div>
                    ) : (
                      <div>
                        {Object.keys(groupedOrders).length === 0 ? (
                          <div>No orders for this table.</div>
                        ) : (
                          Object.entries(groupedOrders).map(
                            ([orderNumber, items], idx) => {
                              const castedItems = items as any[];
                              return (
                                <div
                                  key={orderNumber}
                                  style={{
                                    border: "1px solid #eee",
                                    borderRadius: 6,
                                    marginBottom: 16,
                                    padding: 8,
                                    background: "#fafbfc",
                                  }}
                                >
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "space-between",
                                    }}
                                  >
                                    <div>
                                      <strong>Order No:</strong> {orderNumber}
                                    </div>
                                    <button
                                      style={{
                                        fontSize: 12,
                                        padding: "2px 10px",
                                        borderRadius: 4,
                                        border: "1px solid #1f6f8b",
                                        background: "#fff",
                                        color: "#1f6f8b",
                                        cursor: "pointer",
                                        marginLeft: 8,
                                      }}
                                      onClick={() => {
                                        handleEditOrder(
                                          orderNumber,
                                          castedItems,
                                        );
                                      }}
                                    >
                                      Edit
                                    </button>
                                    <button
                                      style={{
                                        fontSize: 12,
                                        padding: "2px 10px",
                                        borderRadius: 4,
                                        border: "1px solid #DC1818",
                                        background: "#DC1818",
                                        color: "#fff",
                                        cursor: "pointer",
                                        marginLeft: 8,
                                      }}
                                      onClick={() =>
                                        handleCancelOrder(orderNumber)
                                      }
                                    >
                                      Cancel
                                    </button>
                                  </div>
                                  <table
                                    className="checkout-table"
                                    style={{ width: "100%", marginTop: 8 }}
                                  >
                                    <thead>
                                      <tr>
                                        <th>Item</th>
                                        <th>Qty</th>
                                        <th>Status</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {castedItems.map(
                                        (order: any, i: number) => (
                                          <tr key={i}>
                                            <td>
                                              {order.itemName || order.name}
                                            </td>
                                            <td>{order.quantity}</td>
                                            <td>{order.status}</td>
                                          </tr>
                                        ),
                                      )}
                                    </tbody>
                                  </table>
                                </div>
                              );
                            },
                          )
                        )}
                      </div>
                    )}
                  </div>
                )}
              </>
            )}
          </div>
        </ModelEmpty>
      )}

      {/* Delivery Orders Popup — separate flow from dine-in Table Orders */}
      {showDeliveryPopup && (
        <ModelEmpty
          open={showDeliveryPopup}
          setopen={setShowDeliveryPopup}
          className="delivery_orders_popup"
          title="Delivery Orders"
        >
          <div className="delivery_order_list">
            {loadingDeliveryOrders ? (
              <div className="empty_state">
                <p>Loading delivery orders...</p>
              </div>
            ) : (
              <>
                {deliveryOrders.length === 0 && (
                  <div className="empty_state">
                    <p>No pending delivery orders.</p>
                  </div>
                )}
                {deliveryOrders.map(({ orderNumber, items }) => {
                  const first = items[0] || {};
                  return (
                    <div key={orderNumber} className="delivery_order_card">
                      <div className="delivery_order_card_header">
                        <div className="delivery_order_number">
                          Order No: {orderNumber}
                        </div>
                        <div className="delivery_order_actions">
                          <button
                            type="button"
                            className="btn_submit small"
                            onClick={() =>
                              handleOpenMarkDeliveredConfirm(orderNumber, items)
                            }
                          >
                            Mark Delivered
                          </button>
                          <button
                            type="button"
                            className="btn_danger small"
                            onClick={() => handleCancelDeliveryOrder(orderNumber)}
                          >
                            Cancel
                          </button>
                        </div>
                      </div>
                      <div className="delivery_order_details">
                        <div>
                          <strong>Phone:</strong> {first.deliveryPhoneNumber}
                        </div>
                        {first.deliveryAddress && (
                          <div>
                            <strong>Address:</strong> {first.deliveryAddress}
                          </div>
                        )}
                        {first.customerName && (
                          <div>
                            <strong>Customer:</strong> {first.customerName}
                          </div>
                        )}
                        {first.deliveryNote && (
                          <div>
                            <strong>Note:</strong> {first.deliveryNote}
                          </div>
                        )}
                      </div>
                      <table className="checkout-table delivery_order_items">
                        <thead>
                          <tr>
                            <th>Item</th>
                            <th>Qty</th>
                            <th>Status</th>
                          </tr>
                        </thead>
                        <tbody>
                          {items.map((order: any, i: number) => (
                            <tr key={i}>
                              <td>{order.itemName || order.name}</td>
                              <td>{order.quantity}</td>
                              <td>{order.status}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  );
                })}
              </>
            )}
          </div>
        </ModelEmpty>
      )}

      {/* Mark Delivered confirm — decide whether to collect payment (cash on delivery) now */}
      {markDeliveredTarget && (
        <ModelEmpty
          open={!!markDeliveredTarget}
          setopen={() => setMarkDeliveredTarget(null)}
          className="mark_delivered_confirm"
          title="Mark as Delivered"
        >
          <div className="mark_delivered_body">
            <div className="mark_delivered_order_number">
              Order No: {markDeliveredTarget.orderNumber}
            </div>

            {markDeliveredTarget.payment?.hasUnpaidAmount ? (
              <>
                <div className="payment_existing_badge">
                  Outstanding amount: {currencySymbol}{" "}
                  {Number(markDeliveredTarget.payment.unpaidAmount).toFixed(2)}
                </div>
                <label className="checkbox_label">
                  <input
                    type="checkbox"
                    checked={collectPaymentNow}
                    onChange={(e) => setCollectPaymentNow(e.target.checked)}
                  />
                  Collect payment now (cash on delivery)
                </label>

                {collectPaymentNow && (
                  <div className="form_grid three_col">
                    <div className="form_group">
                      <InputText
                        name="deliveryPayCash"
                        label="Cash"
                        type="number"
                        value={deliveryPayCash}
                        onChange={(e) => setDeliveryPayCash(e.target.value)}
                      />
                    </div>
                    <div className="form_group">
                      <InputText
                        name="deliveryPayCard"
                        label="Card"
                        type="number"
                        value={deliveryPayCard}
                        onChange={(e) => setDeliveryPayCard(e.target.value)}
                      />
                    </div>
                    <div className="form_group">
                      <InputText
                        name="deliveryPayBank"
                        label="Bank"
                        type="number"
                        value={deliveryPayBank}
                        onChange={(e) => setDeliveryPayBank(e.target.value)}
                      />
                    </div>
                  </div>
                )}
              </>
            ) : (
              <div className="mark_delivered_paid_note">
                This order is already fully paid.
              </div>
            )}

            <div className="add_form_footer">
              <button
                type="button"
                className="btn_cancel"
                disabled={submittingMarkDelivered}
                onClick={() => setMarkDeliveredTarget(null)}
              >
                Cancel
              </button>
              <button
                type="button"
                className="btn_submit"
                disabled={submittingMarkDelivered}
                onClick={handleConfirmMarkDelivered}
              >
                {submittingMarkDelivered ? "Please wait..." : "Confirm"}
              </button>
            </div>
          </div>
        </ModelEmpty>
      )}

      {/* Order Details Modal */}
      {showOrderDetails && (
        <ModelEmpty
          open={showOrderDetails}
          setopen={setShowOrderDetails}
          className="order-details-modal"
          title="Order Details"
        >
          <div style={{ minWidth: 350, padding: 16 }}>
            {orderDetailsLoading ? (
              <div>Loading order details...</div>
            ) : (
              <>
                {(!orderDetails || orderDetails.length === 0) && (
                  <div>No order details found.</div>
                )}
                {orderDetails && orderDetails.length > 0 && (
                  <table className="checkout-table" style={{ width: "100%" }}>
                    <thead>
                      <tr>
                        <th>Item</th>
                        <th>Qty</th>
                        <th>Price</th>
                        <th>Status</th>
                        <th>Note</th>
                      </tr>
                    </thead>
                    <tbody>
                      {orderDetails.map((item: any, i: number) => (
                        <tr key={i}>
                          <td>
                            {item.Item?.name || item.itemName || item.name}
                          </td>
                          <td>{item.quantity}</td>
                          <td>
                            {currencySymbol}{" "}
                            {item.price ||
                              item.Item?.price ||
                              item.priceHistory?.price ||
                              ""}
                          </td>
                          <td>{item.status}</td>
                          <td>{item.note}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                )}
              </>
            )}
            <button
              className="pos-table-popup-close"
              style={{ marginTop: 10, width: 120 }}
              onClick={() => setShowOrderDetails(false)}
            >
              Close
            </button>
          </div>
        </ModelEmpty>
      )}
    </>
  );
}

export default ActionButtons;
